import { RangeSlider, Badge, Group } from "@mantine/core";
import _ from "lodash";
import React from "react";
import FormReadOnlyField from "./formReadOnlyField";
import { isWidgetReadOnly } from "../helpers/formReadOnly";
import { omitFormRenderContext } from "../helpers/omitFormRenderContext";

const AgeRanger = ({
  form,
  name,
  label,
  defaultValue,
  min = 0,
  max = 100,
  step,
  readOnly = false,
  readonly = false,
  disabled = false,
  ...props
}) => {
  const rangeValue = _.get(form.values, name);
  const sliderValue =
    Array.isArray(rangeValue) && rangeValue.length === 2
      ? rangeValue
      : defaultValue ?? [min, max];
  const display = `${sliderValue[0]} - ${sliderValue[1]}`;

  if (isWidgetReadOnly({ disabled, readOnly, readonly, form })) {
    return <FormReadOnlyField label={label} value={display} />;
  }

  const { onChange, ...sliderInputProps } = form.getInputProps(name, {
    type: props.type,
  });

  return (
    <>
      <Group position="apart">
        {label}
        <Badge variant="dot">{display}</Badge>
      </Group>

      <RangeSlider
        mt={10}
        min={min}
        max={max}
        step={step}
        {...omitFormRenderContext(props)}
        {...sliderInputProps}
        value={sliderValue}
        onChange={onChange}
      />
    </>
  );
};


export default AgeRanger